/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_10167
 */

import { message } from 'ant-design-vue'
import {
  autoPopup_add_post,
  autoPopup_delete_id_delete,
  autoPopup_detail_id_get,
  autoPopup_edit_post,
  autoPopup_list_get,
  autoPopup_delete_id_get
} from 'server/modules/10167' // 新建弹窗
export const autoPopup_add_post_ = async function(state) {
  const { success, data, retInfo } = await autoPopup_add_post({
    ...state.postParams
    // sceneSwitch: state.postParams ? 1 : 0
  })
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除弹窗
export const autoPopup_delete_id_delete_ = async function(params) {
  const { success, data, retInfo } = await autoPopup_delete_id_delete(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 弹窗详情
export const autoPopup_detail_id_get_ = async function(state) {
  const { id } = state.postParams
  const { success, data, retInfo } = await autoPopup_detail_id_get({
    id
  })
  if (success) {
    state.postParams = {
      ...data
      // sceneSwitch: data.postParams - 0 === 1 ? true : false
    }
  } else {
    message.error(retInfo)
  }
}

// 编辑弹窗
export const autoPopup_edit_post_ = async function(state) {
  const { success, data, retInfo } = await autoPopup_edit_post({
    ...state.postParams
  })
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 弹窗列表
export const autoPopup_list_get_ = async function(state) {
  let params = {
    ...state.searchParams,
    ...state.pagination
  }
  const { success, data, retInfo } = await autoPopup_list_get(params)
  if (success) {
    const { list, total } = data
    state.dataSource = list
    state.pagination.total = total
  } else {
    message.error(retInfo)
  }
}

// 删除弹窗
export const autoPopup_delete_id_get_ = async function(params, init) {
  const { success, retInfo } = await autoPopup_delete_id_get(params)
  if (success) {
    init()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
